import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import "./LegalPages.css";

const TermsAndConditions = () => {
    const [title, setTitle] = useState("Terms and Conditions");
    const [content, setContent] = useState("");
    const [lastUpdated, setLastUpdated] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const response = await fetch(
                    "https://admin.newalliedtour.net/api/terms_and_conditions/"
                );
                const data = await response.json();

                if (data) {
                    setTitle(data.title || "Terms and Conditions");
                    // Sanitize HTML content for security
                    const cleanContent = DOMPurify.sanitize(data.content || "", {
                        ALLOWED_TAGS: ["h1", "h2", "h3", "h4", "h5", "h6", "p", "ul", "ol", "li", "b", "strong", "em", "i", "u", "span", "br", "hr", "a"],
                        ALLOWED_ATTR: ["style", "class", "href", "target"]
                    });
                    setContent(cleanContent);

                    // Format date
                    if (data.last_updated) {
                        const date = new Date(data.last_updated);
                        setLastUpdated(date.toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                        }));
                    }
                }
            } catch (error) {
                console.error("Error fetching terms and conditions:", error);
                setContent("<p>Unable to load content. Please try again later.</p>");
            } finally {
                setLoading(false);
            }
        };

        fetchTerms();
    }, []);

    if (loading) {
        return (
            <div className="legal-page">
                <div className="legal-container">
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>{title}</h1>
                {lastUpdated && (
                    <p className="last-updated">Last Updated: {lastUpdated}</p>
                )}
                <div
                    className="legal-content"
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
        </div>
    );
};

export default TermsAndConditions;
